module.exports = __webpack_public_path__ + "img/icon_my_praise@2x.dd8a8845.png";